<template>
  <div class="main">
    <van-nav-bar title="3500用户登录" left-arrow @click-left="onClickLeft"/>

    <van-row type="flex" justify="center" class="img">
      <van-col span="1">&nbsp</van-col>
      <van-col span="22"><img src="" /></van-col>
      <van-col span="1">&nbsp</van-col>
    </van-row>

    <van-row type="flex" justify="center" class="line">
      <van-col span="3">&nbsp</van-col>
      <van-col span="18">
        <van-cell-group>
          <van-field placeholder="请输入用户名" type="text" v-model="username" left-icon="manager"/>
        </van-cell-group>
        <van-cell-group>
          <van-field placeholder="请输入密码"  type="password"  v-model="password" left-icon="lock"/>
        </van-cell-group>
      </van-col>
      <van-col span="3">&nbsp</van-col>
    </van-row>

    <van-row type="flex" justify="center" class="btns">
      <van-col span="3">&nbsp</van-col>
      <van-col span="18">
        <van-button class="jumpBtn" type="primary" @click.native="login()" size="large">登录</van-button>
      </van-col>
      <van-col span="3">&nbsp</van-col>

      <van-col span="3">&nbsp</van-col>
      <van-col span="18">
        <van-button class="jumpBtn" type="warning" @click.native="clearInput()" size="large">清空</van-button>
      </van-col>
      <van-col span="3">&nbsp</van-col>
    </van-row>
    <div style="margin-top: 2%;margin-left: 41%; font-size: 18px; color: grey;font-family: Copperplate">premium</div>
    <div style="margin-top: 10%;margin-left: 17%; font-size: 14px; color: grey">添加 wechat: josephWebchat 申请账号密码</div>

  </div>
</template>

<script>
    import axios from "axios";
    import {Dialog, Toast} from "vant";
    import {Base64} from "js-base64";

    export default {
      name: "login",
      data(){
          return{
              username:'',
              password:''

          }
      },
      methods:{
        onClickLeft() {
          this.$router.push({ name: 'homepage', params: {}});
        },
        // 清除输入框
        clearInput(){
            this.username = ''
            this.password = ''
        },
        // 登录按钮
        login(){
          let res = new Promise((resolve, reject) => {
            resolve(this.queryUsername())
          });
          res = res.then( res =>{
            if(res != 'nook'){
              this.$store.commit('changeLogin', res['token']);
              this.getLocalStorage();
              this.$router.push({ name: 'filter3500', });
              Dialog.alert({
                title: '欢迎3500高考用户',
                message: '感谢付出！作为前期申请用户，可以享受更快速的查询体验',
                theme: 'round-button',
              })
              return 'ok'
            }else{
              Toast.fail("账号密码错误");
            }
          })
          res.then( res => {
            let tokenStr = window.localStorage.getItem('Authorization3500');
            let userString = decodeURIComponent(escape(window.atob(tokenStr.split('.')[1])))
            let tokenData = JSON.parse(userString);
            let username = tokenData['data']['username'];
            this.$store.state.userShow = username.substr(0, 3);
          })

        },
        // 后端请求数据
        async queryUsername() {
          this.$store.state.loadingWords = true;
          let params = new URLSearchParams();
          params.append('method', 'post');
          params.append('username', this.commonApi.trimStr(this.username.toLowerCase()));
          params.append('password', this.password);
          return await axios.post('wordsuser/', params).then( (ret) => {
            this.$store.state.loadingWords = false;
            return ret.data;
          })
        },
        // 加载数据
        getLocalStorage(){
            const words3500Data = new Promise( (resolve, reject) => {
              this.$store.state.loadingWords3500 = true;
              this.$store.state.loadingWords = true;
              const words3500Data = this.commonApi.getWords3500();
              resolve(words3500Data)
            });
            const newWordsData = words3500Data.then( words3500Data => {
              this.$store.state.gaokaoWords = words3500Data['data'];
              localStorage.setItem("words3500", Base64.encode(JSON.stringify(words3500Data)));
              console.log('words3500', words3500Data);
              const newWordsData = this.commonApi.getNewWords();
              return newWordsData
            });
            newWordsData.then( newWordsData => {
              this.$store.state.loadingWords = false;
              // localStorage.setItem("newWords", JSON.stringify(newWordsData));
              localStorage.setItem("newWords", Base64.encode(JSON.stringify(newWordsData)));
              this.$store.state.newWords = newWordsData['data'];
              this.$store.state.loadingWords3500 = false;
              // console.log('newWords:', newWordsData);
            })
        },

      },
      watch:{

      },
      activated() {
      },
      created() {
        window.localStorage.removeItem('words3500');
        window.localStorage.removeItem('newWords');
      }
    }
</script>

<style scoped>
    .background
    {
        /*background-image:url('../assets/bgimage.jpeg');*/
        height: 100%;
        width: 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%
    }
</style>